import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import moment from 'moment-timezone'
import { Segment } from 'semantic-ui-react'
import { actions as sessionsActions } from '../../store/actions/sessions'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { convert } from '../../helpers/timezones'
import ReactLoading from 'react-loading'

class Calendar extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentWeekStart: null,
            loading: true
        }

        this.getWeekKey = this.getWeekKey.bind(this)
        this.fetchSessions = this.fetchSessions.bind(this)
        this.loadWeekSessions = this.loadWeekSessions.bind(this)
        this.handleDatesSet = this.handleDatesSet.bind(this)
    }

    getWeekKey(date) {
        return moment(date).tz(this.props.timezone).format('YYYY-MM-DD')
    }

    async fetchSessions(start, end) {
        try {

            const response = await send({
                method: 'GET',
                tokens: this.props.userTokens,
                url: `/therapist/sessions?start=${start.valueOf()}&end=${end.valueOf()}`
            })
            return response.data.sessions || []
        } catch (error) {
            console.error('Failed to fetch sessions.', error)
            return []
        }
    }

    async loadWeekSessions(weekStart, weekEnd, weekKey) {
        // console.log("loadWeekSessions weekStart:", weekStart)
        // console.log("loadWeekSessions weekEnd:", weekEnd)
        // console.log("loadWeekSessions weekKey:", weekKey)

        if (this.props.sessions[weekKey]) {
            // console.log("sessions for " + weekKey + " exist")
            this.setState({ currentWeekStart: weekKey })
            return
        }

        // Initialize loadingWeeks object
        this.loadingWeeks = this.loadingWeeks || {}

        // If already loading this week, skip
        if (this.loadingWeeks[weekKey]) return

        // Mark this week as loading
        this.loadingWeeks[weekKey] = true

        // console.log("sessions for " + weekKey + " do not exist")
        const start = moment(weekStart).tz(this.props.timezone)
        const end = moment(weekEnd).tz(this.props.timezone)
        const sessionData = await this.fetchSessions(start, end)

        const now = moment().tz(this.props.timezone).valueOf()

        const events = sessionData.map((session, index) => {
            const startDate = convert(session.start, this.props.timezone).toDate() // should return Date or ISO
            const endDate = convert(session.end, this.props.timezone).toDate()

            return {
            title: session.patient.name,
            start: startDate,
            end: endDate,
            extendedProps: {
                participant: session.patient.id
            },
            className:
                now >= start.valueOf() &&
                now <= end.valueOf() &&
                now <= session.end && // make sure session.end is also Date/ISO or convert it
                index === 0
                ? 'next'
                : ''
            }
        })

        this.props.setSessions({ weekKey, value: events })
        this.setState({ currentWeekStart: weekKey })
    }


    handleDatesSet({ start, end }) {
        const weekKey = this.getWeekKey(start)
        // console.log("handleDatesSet weekStart:", start)
        // console.log("handleDatesSet weekEnd:", end)
        // console.log("handleDatesSet weekKey:", weekKey)
        if (!this.state.currentWeekStart || weekKey !== this.state.currentWeekStart) {
            this.loadWeekSessions(start, end, weekKey)
        }
    }

    componentDidMount() {
        // const initialWeekStart = moment().startOf('week').toDate()
        // console.log("componentDidMount initialWeekStart:", initialWeekStart)
        // this.loadWeekSessions(initialWeekStart)
        if (this.props.timezone !== undefined) {
            this.setState({ loading: false });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.timezone !== prevProps.timezone && this.props.timezone) {
            this.setState({ loading: false });
        }
    }

    render() {
        const { currentWeekStart } = this.state
        const currentWeekKey = currentWeekStart ? currentWeekStart : null
        const events = currentWeekKey && this.props.sessions[currentWeekKey]
            ? this.props.sessions[currentWeekKey]
            : []

        // console.log("timezone:", this.props.timezone)
        // console.log("state:", this.state)
        // console.log("all sessions:", this.props.sessions)
        return (
            <Segment className="calendar">
                {this.state.loading ? 
                <div className='performance-loader'>
                    <ReactLoading type='spin' color='#444'/>
                </div> : 
                <FullCalendar
                    plugins={[timeGridPlugin, interactionPlugin, dayGridPlugin]}
                    initialView="timeGridWeek"
                    height="auto"
                    editable={false}
                    dayHeaderFormat={{ weekday: 'short', day: 'numeric' }}
                    titleFormat={{ year: 'numeric', month: 'long' }}
                    firstDay={1}
                    timeZone={this.props.timezone}
                    now={moment().tz(this.props.timezone).format()}
                    headerToolbar={{
                        left: 'today prev,next',
                        center: 'title',
                        right: 'timeGridWeek'
                        // right: 'dayGridMonth, timeGridWeek'
                    }}
                    buttonText={{ today: tr('TODAY') }}
                    allDaySlot={false}
                    nowIndicator
                    locale={this.props.language}
                    events={events}
                    datesSet={this.handleDatesSet}
                    eventClick={(info) =>
                        this.props.history.push(`/participants/${info.event.extendedProps.participant}`)
                    }
                    eventClassNames={(info) => info.event.classNames || []}
                    eventTimeFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                />}
            </Segment>
        )
    }
}

const mapStateToProps = (state) => ({
    language: state.settings.language,
    timezone: state.settings.timezone,
    userTokens: state.users.userTokens,
    sessions: state.sessions.sessions
})

const mapDispatchToProps = (dispatch) => {
    const _sessions = bindActionCreators(sessionsActions, dispatch)
    return {
        setSessions: _sessions.setSessions
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Calendar))



// WEBPACK FOOTER //
// ./src/components/calendar/index.js